var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "500",
      "title": `${_vm.openedDuizhangdan ? '编辑' : '新增'}-对账单`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "disabled": _vm.openedDuizhangdan ? true : false,
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.customerLoading,
      "placeholder": "请填写客户名字后选择"
    },
    model: {
      value: _vm.formItem.customer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "customer", $$v);
      },
      expression: "formItem.customer"
    }
  }, _vm._l(_vm.customersSimple, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "合同签署公司",
      "prop": "company"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (option) {
    return _c('Option', {
      key: option._id,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.abbr))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "开始日期",
      "prop": "startDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择开始日期"
    },
    model: {
      value: _vm.formItem.startDate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "startDate", $$v);
      },
      expression: "formItem.startDate"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "结束日期",
      "prop": "endDate"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择结束日期"
    },
    model: {
      value: _vm.formItem.endDate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "endDate", $$v);
      },
      expression: "formItem.endDate"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "欠款金额（元）",
      "prop": "debtAmount"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: _vm.formItem.debtAmount,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "debtAmount", $$v);
      },
      expression: "formItem.debtAmount"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入备注...",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      }
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }